// import SceneFloor from './models/SceneFloor';
import { environment } from '../../../environments/environment';
let baseMuseumUrl = environment.baseMuseumUrl;
//let baseMuseumUrl = process.env.BASE_MUSEUM_URL || 'https://ellesdafrique.fr/museum/frames/';
baseMuseumUrl = baseMuseumUrl.replace(/\/$/, '');

import { SceneFloor } from './models/SceneFloor';
export const Scene1Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/15`,
    Scene2:  `${baseMuseumUrl}/14`,
    Scene3:  `${baseMuseumUrl}/13`,
    Scene4:  `${baseMuseumUrl}/12`,
    Scene5:  `${baseMuseumUrl}/11`,
    Scene6:  `${baseMuseumUrl}/10`,
    Scene7:  `${baseMuseumUrl}/1`,
    Scene8:  `${baseMuseumUrl}/2`,
    Scene9:  `${baseMuseumUrl}/3`,
    Scene10: `${baseMuseumUrl}/4`,
    Scene11: `${baseMuseumUrl}/5`,
    Scene12: `${baseMuseumUrl}/6`,
    Scene13: `${baseMuseumUrl}/7`,
    Scene14: `${baseMuseumUrl}/8`,
    Scene15: `${baseMuseumUrl}/9`,
}

export const Scene2Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/30`,
    Scene2:  `${baseMuseumUrl}/29`,
    Scene3:  `${baseMuseumUrl}/28`,
    Scene4:  `${baseMuseumUrl}/27`,
    Scene5:  `${baseMuseumUrl}/26`,
    Scene6:  `${baseMuseumUrl}/25`,
    Scene7:  `${baseMuseumUrl}/16`,
    Scene8:  `${baseMuseumUrl}/17`,
    Scene9:  `${baseMuseumUrl}/18`,
    Scene10: `${baseMuseumUrl}/19`,
    Scene11: `${baseMuseumUrl}/20`,
    Scene12: `${baseMuseumUrl}/21`,
    Scene13: `${baseMuseumUrl}/22`,
    Scene14: `${baseMuseumUrl}/23`,
    Scene15: `${baseMuseumUrl}/24`,
}

export const Scene3Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/45`,
    Scene2:  `${baseMuseumUrl}/44`,
    Scene3:  `${baseMuseumUrl}/43`,
    Scene4:  `${baseMuseumUrl}/42`,
    Scene5:  `${baseMuseumUrl}/41`,
    Scene6:  `${baseMuseumUrl}/40`,
    Scene7:  `${baseMuseumUrl}/31`,
    Scene8:  `${baseMuseumUrl}/32`,
    Scene9:  `${baseMuseumUrl}/33`,
    Scene10: `${baseMuseumUrl}/34`,
    Scene11: `${baseMuseumUrl}/35`,
    Scene12: `${baseMuseumUrl}/36`,
    Scene13: `${baseMuseumUrl}/37`,
    Scene14: `${baseMuseumUrl}/38`,
    Scene15: `${baseMuseumUrl}/39`,
}

export const Scene4Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/60`,
    Scene2:  `${baseMuseumUrl}/59`,
    Scene3:  `${baseMuseumUrl}/58`,
    Scene4:  `${baseMuseumUrl}/57`,
    Scene5:  `${baseMuseumUrl}/56`,
    Scene6:  `${baseMuseumUrl}/55`,
    Scene7:  `${baseMuseumUrl}/46`,
    Scene8:  `${baseMuseumUrl}/47`,
    Scene9:  `${baseMuseumUrl}/48`,
    Scene10: `${baseMuseumUrl}/49`,
    Scene11: `${baseMuseumUrl}/50`,
    Scene12: `${baseMuseumUrl}/51`,
    Scene13: `${baseMuseumUrl}/52`,
    Scene14: `${baseMuseumUrl}/53`,
    Scene15: `${baseMuseumUrl}/54`,
}
export const Scene5Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/75`,
    Scene2:  `${baseMuseumUrl}/74`,
    Scene3:  `${baseMuseumUrl}/73`,
    Scene4:  `${baseMuseumUrl}/72`,
    Scene5:  `${baseMuseumUrl}/71`,
    Scene6:  `${baseMuseumUrl}/70`,
    Scene7:  `${baseMuseumUrl}/61`,
    Scene8:  `${baseMuseumUrl}/62`,
    Scene9:  `${baseMuseumUrl}/63`,
    Scene10: `${baseMuseumUrl}/64`,
    Scene11: `${baseMuseumUrl}/65`,
    Scene12: `${baseMuseumUrl}/66`,
    Scene13: `${baseMuseumUrl}/67`,
    Scene14: `${baseMuseumUrl}/68`,
    Scene15: `${baseMuseumUrl}/69`,
}
export const Scene6Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/90`,
    Scene2:  `${baseMuseumUrl}/89`,
    Scene3:  `${baseMuseumUrl}/88`,
    Scene4:  `${baseMuseumUrl}/87`,
    Scene5:  `${baseMuseumUrl}/86`,
    Scene6:  `${baseMuseumUrl}/85`,
    Scene7:  `${baseMuseumUrl}/76`,
    Scene8:  `${baseMuseumUrl}/77`,
    Scene9:  `${baseMuseumUrl}/78`,
    Scene10: `${baseMuseumUrl}/79`,
    Scene11: `${baseMuseumUrl}/80`,
    Scene12: `${baseMuseumUrl}/81`,
    Scene13: `${baseMuseumUrl}/82`,
    Scene14: `${baseMuseumUrl}/83`,
    Scene15: `${baseMuseumUrl}/84`,
}
export const Scene7Floor: SceneFloor = {
    Scene1:  `${baseMuseumUrl}/105`,
    Scene2:  `${baseMuseumUrl}/104`,
    Scene3:  `${baseMuseumUrl}/103`,
    Scene4:  `${baseMuseumUrl}/102`,
    Scene5:  `${baseMuseumUrl}/101`,
    Scene6:  `${baseMuseumUrl}/100`,
    Scene7:  `${baseMuseumUrl}/91`,
    Scene8:  `${baseMuseumUrl}/92`,
    Scene9:  `${baseMuseumUrl}/93`,
    Scene10: `${baseMuseumUrl}/94`,
    Scene11: `${baseMuseumUrl}/95`,
    Scene12: `${baseMuseumUrl}/96`,
    Scene13: `${baseMuseumUrl}/97`,
    Scene14: `${baseMuseumUrl}/98`,
    Scene15: `${baseMuseumUrl}/99`,
}
// export const Scene1Floor: SceneFloor = {
//     Scene1:  'https://ellesdafrique.fr/museum/frames/15',
//     Scene2:  'https://ellesdafrique.fr/museum/frames/14',
//     Scene3:  'https://ellesdafrique.fr/museum/frames/13',
//     Scene4:  'https://ellesdafrique.fr/museum/frames/12',
//     Scene5:  'https://ellesdafrique.fr/museum/frames/11',
//     Scene6:  'https://ellesdafrique.fr/museum/frames/10',
//     Scene7:  'https://ellesdafrique.fr/museum/frames/1',
//     Scene8:  'https://ellesdafrique.fr/museum/frames/2',
//     Scene9:  'https://ellesdafrique.fr/museum/frames/3',
//     Scene10: 'https://ellesdafrique.fr/museum/frames/4',
//     Scene11: 'https://ellesdafrique.fr/museum/frames/5',
//     Scene12: 'https://ellesdafrique.fr/museum/frames/6',
//     Scene13: 'https://ellesdafrique.fr/museum/frames/7',
//     Scene14: 'https://ellesdafrique.fr/museum/frames/8',
//     Scene15: 'https://ellesdafrique.fr/museum/frames/9',
// }

// export const Scene2Floor: SceneFloor = {
//     Scene1:  'https://ellesdafrique.fr/museum/frames/30',
//     Scene2:  'https://ellesdafrique.fr/museum/frames/29',
//     Scene3:  'https://ellesdafrique.fr/museum/frames/28',
//     Scene4:  'https://ellesdafrique.fr/museum/frames/27',
//     Scene5:  'https://ellesdafrique.fr/museum/frames/26',
//     Scene6:  'https://ellesdafrique.fr/museum/frames/25',
//     Scene7:  'https://ellesdafrique.fr/museum/frames/16',
//     Scene8:  'https://ellesdafrique.fr/museum/frames/17',
//     Scene9:  'https://ellesdafrique.fr/museum/frames/18',
//     Scene10: 'https://ellesdafrique.fr/museum/frames/19',
//     Scene11: 'https://ellesdafrique.fr/museum/frames/20',
//     Scene12: 'https://ellesdafrique.fr/museum/frames/21',
//     Scene13: 'https://ellesdafrique.fr/museum/frames/22',
//     Scene14: 'https://ellesdafrique.fr/museum/frames/23',
//     Scene15: 'https://ellesdafrique.fr/museum/frames/24',
// }

// export const Scene3Floor: SceneFloor = {
//     Scene1:  'https://ellesdafrique.fr/museum/frames/45',
//     Scene2:  'https://ellesdafrique.fr/museum/frames/44',
//     Scene3:  'https://ellesdafrique.fr/museum/frames/43',
//     Scene4:  'https://ellesdafrique.fr/museum/frames/42',
//     Scene5:  'https://ellesdafrique.fr/museum/frames/41',
//     Scene6:  'https://ellesdafrique.fr/museum/frames/40',
//     Scene7:  'https://ellesdafrique.fr/museum/frames/31',
//     Scene8:  'https://ellesdafrique.fr/museum/frames/32',
//     Scene9:  'https://ellesdafrique.fr/museum/frames/33',
//     Scene10: 'https://ellesdafrique.fr/museum/frames/34',
//     Scene11: 'https://ellesdafrique.fr/museum/frames/35',
//     Scene12: 'https://ellesdafrique.fr/museum/frames/36',
//     Scene13: 'https://ellesdafrique.fr/museum/frames/37',
//     Scene14: 'https://ellesdafrique.fr/museum/frames/38',
//     Scene15: 'https://ellesdafrique.fr/museum/frames/39',
// }

// export const Scene4Floor: SceneFloor = {
//     Scene1:  'https://ellesdafrique.fr/museum/frames/60',
//     Scene2:  'https://ellesdafrique.fr/museum/frames/59',
//     Scene3:  'https://ellesdafrique.fr/museum/frames/58',
//     Scene4:  'https://ellesdafrique.fr/museum/frames/57',
//     Scene5:  'https://ellesdafrique.fr/museum/frames/56',
//     Scene6:  'https://ellesdafrique.fr/museum/frames/55',
//     Scene7:  'https://ellesdafrique.fr/museum/frames/46',
//     Scene8:  'https://ellesdafrique.fr/museum/frames/47',
//     Scene9:  'https://ellesdafrique.fr/museum/frames/48',
//     Scene10: 'https://ellesdafrique.fr/museum/frames/49',
//     Scene11: 'https://ellesdafrique.fr/museum/frames/50',
//     Scene12: 'https://ellesdafrique.fr/museum/frames/51',
//     Scene13: 'https://ellesdafrique.fr/museum/frames/52',
//     Scene14: 'https://ellesdafrique.fr/museum/frames/53',
//     Scene15: 'https://ellesdafrique.fr/museum/frames/54',
// }
